// extracted by mini-css-extract-plugin
export default {"CardHeader":"Cards_CardHeader__h1Rrl","CardBody":"Cards_CardBody__J7Evi"};